import { Icon, Stack } from '@fluentui/react';

import type { SortableField, SortDirection } from '../types/sorting';

interface SortableHeaderProps {
  columnName: string;
  field: SortableField;
  sortField?: SortableField | null;
  sortDirection?: SortDirection;
  onSort?: (field: SortableField) => void;
}

export const SortableHeader = (props: SortableHeaderProps) => {
  const { columnName, field, sortField = null, sortDirection = 'asc', onSort } = props;
  const isSorted = sortField === field;
  const isDescending = sortField === field && sortDirection === 'desc';

  return (
    <Stack
      horizontal
      tokens={{ childrenGap: 4 }}
      verticalAlign="center"
      style={{ cursor: onSort ? 'pointer' : 'default', userSelect: 'none' }}
      onClick={() => onSort?.(field)}
    >
      <span>{columnName}</span>
      {isSorted && (
        <Icon
          iconName={isDescending ? 'ChevronDown' : 'ChevronUp'}
          style={{ fontSize: 12, marginLeft: 8 }}
          data-test="sort-indicator"
        />
      )}
    </Stack>
  );
};
